import script from "./jiaoshi.vue?vue&type=script&setup=true&lang=js"
export * from "./jiaoshi.vue?vue&type=script&setup=true&lang=js"

import "./jiaoshi.vue?vue&type=style&index=0&id=cf40d51c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf40d51c"]])

export default __exports__